/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as AuthViewsRouteImport } from './routes/_auth/views'
import { Route as AuthRationRouteImport } from './routes/_auth/ration'
import { Route as AuthInventoryRouteImport } from './routes/_auth/inventory'
import { Route as AuthConfigRouteImport } from './routes/_auth/config'
import { Route as AuthAuditRouteImport } from './routes/_auth/audit'
import { Route as AuthAlertsRouteImport } from './routes/_auth/alerts'
import { Route as AuthHerdIndexRouteImport } from './routes/_auth/herd/index'
import { Route as AuthLogFeedingRouteImport } from './routes/_auth/log/feeding'
import { Route as AuthLogEventRouteImport } from './routes/_auth/log/event'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthViewsRoute = AuthViewsRouteImport.update({
  id: '/views',
  path: '/views',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRationRoute = AuthRationRouteImport.update({
  id: '/ration',
  path: '/ration',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInventoryRoute = AuthInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => AuthRoute,
} as any)
const AuthConfigRoute = AuthConfigRouteImport.update({
  id: '/config',
  path: '/config',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuditRoute = AuthAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAlertsRoute = AuthAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => AuthRoute,
} as any)
const AuthHerdIndexRoute = AuthHerdIndexRouteImport.update({
  id: '/herd/',
  path: '/herd/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLogFeedingRoute = AuthLogFeedingRouteImport.update({
  id: '/log/feeding',
  path: '/log/feeding',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLogEventRoute = AuthLogEventRouteImport.update({
  id: '/log/event',
  path: '/log/event',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/login': typeof LoginRoute
  '/alerts': typeof AuthAlertsRoute
  '/audit': typeof AuthAuditRoute
  '/config': typeof AuthConfigRoute
  '/inventory': typeof AuthInventoryRoute
  '/ration': typeof AuthRationRoute
  '/views': typeof AuthViewsRoute
  '/log/event': typeof AuthLogEventRoute
  '/log/feeding': typeof AuthLogFeedingRoute
  '/herd/': typeof AuthHerdIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/alerts': typeof AuthAlertsRoute
  '/audit': typeof AuthAuditRoute
  '/config': typeof AuthConfigRoute
  '/inventory': typeof AuthInventoryRoute
  '/ration': typeof AuthRationRoute
  '/views': typeof AuthViewsRoute
  '/': typeof AuthIndexRoute
  '/log/event': typeof AuthLogEventRoute
  '/log/feeding': typeof AuthLogFeedingRoute
  '/herd': typeof AuthHerdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/_auth/alerts': typeof AuthAlertsRoute
  '/_auth/audit': typeof AuthAuditRoute
  '/_auth/config': typeof AuthConfigRoute
  '/_auth/inventory': typeof AuthInventoryRoute
  '/_auth/ration': typeof AuthRationRoute
  '/_auth/views': typeof AuthViewsRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/log/event': typeof AuthLogEventRoute
  '/_auth/log/feeding': typeof AuthLogFeedingRoute
  '/_auth/herd/': typeof AuthHerdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/alerts'
    | '/audit'
    | '/config'
    | '/inventory'
    | '/ration'
    | '/views'
    | '/log/event'
    | '/log/feeding'
    | '/herd/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/alerts'
    | '/audit'
    | '/config'
    | '/inventory'
    | '/ration'
    | '/views'
    | '/'
    | '/log/event'
    | '/log/feeding'
    | '/herd'
  id:
    | '__root__'
    | '/_auth'
    | '/login'
    | '/_auth/alerts'
    | '/_auth/audit'
    | '/_auth/config'
    | '/_auth/inventory'
    | '/_auth/ration'
    | '/_auth/views'
    | '/_auth/'
    | '/_auth/log/event'
    | '/_auth/log/feeding'
    | '/_auth/herd/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/views': {
      id: '/_auth/views'
      path: '/views'
      fullPath: '/views'
      preLoaderRoute: typeof AuthViewsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/ration': {
      id: '/_auth/ration'
      path: '/ration'
      fullPath: '/ration'
      preLoaderRoute: typeof AuthRationRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/inventory': {
      id: '/_auth/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof AuthInventoryRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/config': {
      id: '/_auth/config'
      path: '/config'
      fullPath: '/config'
      preLoaderRoute: typeof AuthConfigRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/audit': {
      id: '/_auth/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuthAuditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/alerts': {
      id: '/_auth/alerts'
      path: '/alerts'
      fullPath: '/alerts'
      preLoaderRoute: typeof AuthAlertsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/herd/': {
      id: '/_auth/herd/'
      path: '/herd'
      fullPath: '/herd/'
      preLoaderRoute: typeof AuthHerdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/log/feeding': {
      id: '/_auth/log/feeding'
      path: '/log/feeding'
      fullPath: '/log/feeding'
      preLoaderRoute: typeof AuthLogFeedingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/log/event': {
      id: '/_auth/log/event'
      path: '/log/event'
      fullPath: '/log/event'
      preLoaderRoute: typeof AuthLogEventRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthAlertsRoute: typeof AuthAlertsRoute
  AuthAuditRoute: typeof AuthAuditRoute
  AuthConfigRoute: typeof AuthConfigRoute
  AuthInventoryRoute: typeof AuthInventoryRoute
  AuthRationRoute: typeof AuthRationRoute
  AuthViewsRoute: typeof AuthViewsRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthLogEventRoute: typeof AuthLogEventRoute
  AuthLogFeedingRoute: typeof AuthLogFeedingRoute
  AuthHerdIndexRoute: typeof AuthHerdIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAlertsRoute: AuthAlertsRoute,
  AuthAuditRoute: AuthAuditRoute,
  AuthConfigRoute: AuthConfigRoute,
  AuthInventoryRoute: AuthInventoryRoute,
  AuthRationRoute: AuthRationRoute,
  AuthViewsRoute: AuthViewsRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthLogEventRoute: AuthLogEventRoute,
  AuthLogFeedingRoute: AuthLogFeedingRoute,
  AuthHerdIndexRoute: AuthHerdIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
